import { Provider } from 'function-tree';

export default (function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(Provider, [null].concat(args)))();
});
//# sourceMappingURL=Provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/es/Provider.js
// module id = 77
// module chunks = 5